var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout app-layout-simple"},[_c('b-container',{attrs:{"fluid":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }